import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UxService } from '~/app/core/services';
import { RoleService } from '../../core/services';
import { Calendar } from '../models/calendar.model';
import { WelcomeApi } from './welcome-api.base';

@Injectable()
export class CalendarService extends WelcomeApi<Calendar> {
  constructor(
    http: HttpClient,
    roleService: RoleService,
    uxService: UxService) {
    super('v1/calendars', http, roleService, uxService);
  }
}
